import React from 'react';
import PropTypes from 'prop-types';
import Img from './Img';
import './styles.scss';

const FeedImage = (props) => {
  const images = [props.src, props.fallbackImgSrc];
  const { style: styleProps } = props;
  const style = { position: 'relative', height: '100%', width: '100%', ...styleProps };
  return (
    <span className="feed-image-wrapper" style={style}>
      <Img
        className="loaded-image"
        src={images}
        stayOnLastGood
        unloader={(<img src={props.fallbackImgSrc}  className="loaded-image" />)} />
    </span>
  );
};

FeedImage.propTypes = {
  style: PropTypes.shape({}),
  src: PropTypes.string,
  fallbackImgSrc: PropTypes.string,
};

FeedImage.defaultProps = {
  style: {},
  src: null,
  fallbackImgSrc: null,
};

export default FeedImage;
